import { For } from 'solid-js';
import { workflow } from '~/data/categories';
import './Workflow.css';

interface Props {
  onRequestClick?: () => void;
}

export function Workflow(props: Props) {
  return (
    <section class="section workflow" id="how">
      <div class="container">
        <div class="section-head" data-reveal>
          <div class="eyebrow">Как мы работаем</div>
          <h2>От первого сообщения до&nbsp;доставки агрегата</h2>
          <p class="section-head__lead">
            Прозрачные этапы, без лишних созвонов и пустых обещаний. На каждом шаге согласовываем детали и сроки.
          </p>
        </div>

        <ol class="workflow__list">
          <For each={workflow}>
            {(item, i) => (
              <li class="workflow__item" data-reveal style={`--delay:${i() * 80}ms`}>
                <div class="workflow__step">{item.step}</div>
                <p class="workflow__text">{item.text}</p>
              </li>
            )}
          </For>
        </ol>

        <div class="workflow__cta" data-reveal>
          <button class="btn btn--red" onClick={props.onRequestClick}>
            Получить расчёт <span class="btn__arrow">→</span>
          </button>
        </div>
      </div>
    </section>
  );
}
